import * as aspSettings from '@core_n/asp/aspSettings';
import * as aspObjects from '@core_n/asp/aspObjects';
import * as enums from '@core_n/common/enums';
import * as projEnums from '../common/projEnums';
import * as units from '@core_n/common/units';
import * as utils from '@core_n/common/utils';
import { ObjectType } from '@core_n/asp/AspObject';
import { IObjectsPool } from '@core_n/asp/interfaces';
import { TrackCoreObject } from '@core_n/asp/TrackCoreObject';
import { TreeModule } from '@circlon/angular-tree-component';
import { settings } from 'cluster';
import { userSettings } from '@core_n/common/settings';

var IP_FACTOR = 3; // factor to enlarge IP ellipse
export var IP_HIST_COUNT = 20;

var SYSTEM_TRACK_COLOR = [0.5, 0.1, 0.8]; // violet
var INTERCEPTOR_TRACK_COLOR = aspSettings.colorOfIdentity(enums.Hostility.Friend);

var DUPLICATED_SYSTEM_TRACK_COLOR = utils.newmiLighterColor(SYSTEM_TRACK_COLOR, 0.6);
var DUPLICATED_INTERCEPTOR_TRACK_COLOR = utils.newmiLighterColor(INTERCEPTOR_TRACK_COLOR, 0.25);

export class TrackIp {
  private _polySet: boolean = false;
  private ellipse: any;

  line: any;
  poly: any;

  constructor() {
    // this.ellipse = new NeWMI.Geometry.Ellipse();
    this.line = new NeWMI.Geometry.Polyline();

    // ???
    this.poly = new NeWMI.Geometry.Polygon();
    // for (let i = 0; i < 4; i++) {
    //   this.poly.points.push(new NeWMI.Geometry.Point());
    // }
    this.line.points.push(new NeWMI.Geometry.Point()); // ellipse location
    this.line.points.push(new NeWMI.Geometry.Point()); // track location
  }

  get polySet() {
    return this._polySet;
  }

  setTrackLocation(geometry) {
    if (this.line.points.length == 1)
      this.line.points.push(new NeWMI.Geometry.Point());
    this.line.points[1].x = geometry.x;
    this.line.points[1].y = geometry.y;
    this.line.points[1].z = geometry.z;
  }

  clearTrackLocation() {
    if (this.line.points.length == 2)
      this.line.points.pop();
  }

  setPolygon(origin, pointList: any) {
    this.line.points[0].x = origin.x;
    this.line.points[0].y = origin.y;
    this.line.points[0].z = origin.z;
    this.poly = new NeWMI.Geometry.Polygon();
    for (let i = 0; i < pointList.length - 1; i++) {
      this.poly.points.push(new NeWMI.Geometry.Point({ x: pointList[i].Long * units.RAD_TO_DEG, y: pointList[i].Lat * units.RAD_TO_DEG, z: 1000 }));
      // this.poly.points[i].x = pointList[i].Long * units.RAD_TO_DEG;
      // this.poly.points[i].y = pointList[i].Lat * units.RAD_TO_DEG;
      // this.poly.points[i].z = 1000;
    }

    this._polySet = true;
  }

  // setEllipse(origin, major, minor, azimuth) {
  //   this.line.points[0].x = origin.x;
  //   this.line.points[0].y = origin.y;
  //   this.line.points[0].z = origin.z;

  //   // if (this._ellipseSet) {
  //   //   if (this.prevEllipses.length == 0 || !this.compareEllipse(this.ellipse, this.prevEllipses[this.prevEllipses.length - 1])) {
  //   //     // add ellipse to head of array, remove tail if maximum length reached
  //   //     this.prevEllipses.unshift(this.ellipse.clone());
  //   //     if (this.prevEllipses.length > IP_HIST_COUNT)
  //   //       this.prevEllipses.pop();
  //   //   }
  //   // }

  //   this.ellipse.x = origin.x;
  //   this.ellipse.y = origin.y;
  //   this.ellipse.setZ(origin.z);

  //   // convert to NeWMI style
  //   let rad1 = utils.distanceMeterToDeg(origin, major / 2.0);
  //   let rad2 = utils.distanceMeterToDeg(origin, minor / 2.0);
  //   this.ellipse.xRadius = rad2;
  //   this.ellipse.yRadius = rad1;
  //   this.ellipse.angle = NeWMI.Service.Math.ConversionsSvc.fixAngleRadians(azimuth);
  // }

  setPolyFromJson(location, poly) {
    let origin = {
      x: (location.CenterLocLong * units.RAD_TO_DEG) + aspSettings.deltaX,
      y: (location.CenterLocLat * units.RAD_TO_DEG) + aspSettings.deltaY,
      // z: location.ImpactLocationAlt
      z: 5000
    };

    this.setPolygon(origin, poly);
  }

  // setEllipseFromJson(location, ellipse) {
  //   let origin = {
  //     x: (location.ImpactLocationLong * units.RAD_TO_DEG) + aspSettings.deltaX,
  //     y: (location.ImpactLocationLat * units.RAD_TO_DEG) + aspSettings.deltaY,
  //     z: location.ImpactLocationAlt
  //   };

  //   this.setEllipse(origin, ellipse.EllipseMajorAxis * IP_FACTOR, ellipse.EllipseMinorAxis * IP_FACTOR, ellipse.EllipseAzimuth);
  // }

  // private compareEllipse(el1, el2): boolean {
  //   return el1.x == el2.x && el1.y == el2.y && el1.z == el2.z &&
  //     el1.xRadius == el2.xRadius && el1.yRadius == el2.yRadius && el1.angle == el2.angle;
  // }

  private comparePoly(poly1, poly2): boolean {
    if (poly1.length != poly2.length) {
      return false;
    }

    for (let i = 0; i < poly1.length; i++) {
      if (poly1[i].Lat != poly2[i].Lat) {
        return false;
      }
      if (poly1[i].Long != poly2[i].Long) {
        return false;
      }
    }

    return true;
  }
}

export class TrackThreat {
  private _polySet: boolean = false;

  poly: any;
  constructor() {
    this.poly = new NeWMI.Geometry.Polygon();
  }

  get polySet() {
    return this._polySet;
  }

  setPolyFromJson(poly): boolean {
    this.poly = new NeWMI.Geometry.Polygon();
    for (let i = 0; i < poly.length - 1; i++)
      this.poly.points.push(new NeWMI.Geometry.Point({ x: poly[i].Long * units.RAD_TO_DEG, y: poly[i].Lat * units.RAD_TO_DEG, z: 1000 }));

    this._polySet = true;
    return true;
  }

  private comparePoly(poly1, poly2): boolean {
    if (poly1.length != poly2.length) {
      return false;
    }

    for (let i = 0; i < poly1.length; i++) {
      if (poly1[i].Lat != poly2[i].Lat) {
        return false;
      }
      if (poly1[i].Long != poly2[i].Long) {
        return false;
      }
    }

    return true;
  }
}

export class TrackBallisticManeuver {

  status: projEnums.BallisticManeuver;
  horizontalValue: number; // m/sec^2
  horizontalError: number; // m/sec^2
  verticalValue: number; // m/sec^2
  verticalError: number; // m/sec^2

  setManeuverFromJson(maneuver) {
    this.status = maneuver.status;
    this.horizontalValue = maneuver.horiz;
    this.horizontalError = maneuver.horizErr;
    this.verticalValue = maneuver.vert;
    this.verticalError = maneuver.vertErr;
  }
}

export class TrackObject extends TrackCoreObject {
  targetFamily: projEnums.TargetFamily = projEnums.TargetFamily.Unknown;
  missileBurnoutStatus: projEnums.BurnoutStatus;
  accelerationX: number;
  accelerationY: number;
  accelerationZ: number;
  spinRate: number;
  prevHostility: enums.Hostility = 0;

  ip: TrackIp = null;
  threatPoly: TrackThreat = null;

  isDuplicated: boolean;

  public sentToSmart: boolean = false;
  public HideSendToSmart: boolean = false;

  constructor(objectsPool: IObjectsPool, objectType: ObjectType, public trackID: string) {
    super(objectsPool, objectType, trackID);
  }

  // Override TrackCoreObject
  getColor() {
    return super.getColor();
  }

  protected updateDynamics(x, y, z, hdg, spd, vz) {
    super.updateDynamics(x, y, z, hdg, spd, vz);
  }

  protected postHandleMsg(msgObj: any) {
    this.trackPltf = enums.AirPltf.NoStatement;
    this.missileBurnoutStatus = projEnums.BurnoutStatus.Unknown;

    if (this.ip)
      this.ip.setTrackLocation(this.geometry);

    if (msgObj.SentToSmart != undefined)
      this.sentToSmart = msgObj.SentToSmart;

    if (msgObj.HideSendToSmart != undefined)
      this.HideSendToSmart = msgObj.HideSendToSmart;

    let chg = false;
    if (this.prevHostility != this.hostility) {
      chg = true;
      this.prevHostility = this.hostility;
    }

    if (this.trackStatus > 1 || chg) {
      this.threatPoly = null;
      this.update();
    }
  }

  public handleIp(msgObj) {
    this.ip = this.setIp(this.ip, msgObj.CenterPosition, msgObj.Polygon);
  }

  private setIp(Ip: TrackIp, location, polygon) {
    let result: TrackIp = Ip;
    if (location && polygon) {
      if (result == null)
        result = new TrackIp();
      result.setPolyFromJson(location, polygon);
    }
    if (result) {
      if (this.geometry && (this.geometry.x != 0 || this.geometry.y != 0) && userSettings.userPerm == enums.Permission.ADMIN)
        result.setTrackLocation(this.geometry);
      else
        result.clearTrackLocation();
    }
    return result;
  }

  public handleThreat(msgObj) {
    this.threatPoly = this.setThreat(this.threatPoly, msgObj.Polygon);
  }

  private setThreat(Threat: TrackThreat, polygon) {
    let result: TrackThreat = Threat;
    if (polygon) {
      if (result == null)
        result = new TrackThreat();
      result.setPolyFromJson(polygon);
    }
    return result;
  }

  // to be used by ARO table display
  aroTableFieldsWidth(): string[] {
    return ['10ch', '7ch', '7ch', '6ch'];
  }
  aroTableFields(): string[] {
    return ["",
      projEnums.targetFamilyTitle(this.targetFamily).toUpperCase(),
      `${units.altitudeValue(this.geometry.z)}${units.altitudeUnits()}`,
      `${units.speedValue(this.speed)}${units.speedUnits()}`
    ];
  }
  aroTableShowNationality(): boolean {
    return false;
  }

  // to be used by auxiliary DB label display
  auxDbLabelText(): string {
    if (this.trackType == enums.TrackType.TBM)
      return projEnums.burnoutStatusTitle(this.missileBurnoutStatus).toUpperCase();
    return null;
  }

  public update() {
    this.notifyDataChange();
  }

}

